export * from './home-slider.model';
export * from './home-slider.service';
export * from './home-slider-form.service';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/shared/index.ts